import { VALUE_FORMATS } from "./constants"

const METRIC_TYPE_DEFINITIONS = {
  netContribution: {
    id: "netContribution",
    label: "Net Contribution",
    format: VALUE_FORMATS.NUMBER,
    secondaryText: "The position's net contribution to the instrument.",
    dataPath: ({ prefix, factorId }) => `${prefix}.${factorId}.netContribution`,
  },
  currencyExposure: {
    id: "currencyExposure",
    label: "Currency Exposure",
    format: VALUE_FORMATS.CURRENCY,
    secondaryText: "Exposure in risk model numeraire currency.",
    dataPath: ({ prefix, factorId }) => `${prefix}.${factorId}.currencyExposure`,
  },
  zScore: {
    id: "securityExposure",
    label: "Raw asset score",
    format: VALUE_FORMATS.NUMBER,
    secondaryText: ({ isContentSet }) => isContentSet ? "Exposure scores per-security as provided by the content set." : "Exposure scores per-security as provided by the risk model.",
    dataPath: ({ prefix, factorId }) => `${prefix}.${factorId}.securityExposure`,
  },
  betaStandalone: {
    id: "standalone",
    label: "Standalone",
    format: VALUE_FORMATS.NUMBER,
    secondaryText: "The position's beta without correlations to other assets of the instrument.",
    dataPath: ({ prefix, factorId }) => `${prefix}.securityBeta.${factorId}`,
  },
  sensitivityStandalone: {
    id: "standalone",
    label: "Standalone",
    format: VALUE_FORMATS.PERCENT,
    secondaryText: "Per-security factor sensitivity as calculated by factor volatility * security's factor exposure.",
    dataPath: ({ prefix, factorId }) => `${prefix}.${factorId}.standalone`,
  },
  sensitivityNetContribution: {
    id: "netContribution",
    label: "Net Contribution",
    format: VALUE_FORMATS.PERCENT,
    secondaryText: "The position's net contribution to the instrument.",
    dataPath: ({ prefix, factorId }) => `${prefix}.${factorId}.netContribution`,
  },
  cumulativePercent: {
    id: "cumulativePercent",
    label: "Net Contribution",
    format: VALUE_FORMATS.PERCENT,
    secondaryText: "The position's net contribution to the instrument.",
    dataPath: ({ prefix, factorId }) => `${prefix}.${factorId}.cumulativePercent`,
  },
  cumulativeCurrency: {
    id: "cumulativeCurrency",
    label: "Currency Performance",
    format: VALUE_FORMATS.CURRENCY,
    secondaryText: "Performance in numeraire currency.",
    dataPath: ({ prefix, factorId }) => `${prefix}.${factorId}.cumulativeCurrency`,
  },
  betaNetContribution: {
    id: "betaNetContribution",
    label: "Net Contribution",
    format: VALUE_FORMATS.NUMBER,
    secondaryText: "The position's net contribution to the instrument.",
    dataPath: ({ prefix, factorId }) => `${prefix}.${factorId}`,
  },
}

export const METRIC_OPTIONS = {
  exposure: [
    { ...METRIC_TYPE_DEFINITIONS.netContribution, isDefault: true },
    METRIC_TYPE_DEFINITIONS.currencyExposure,
    METRIC_TYPE_DEFINITIONS.zScore,
  ],
  sensitivity: [
    { ...METRIC_TYPE_DEFINITIONS.netContribution, isDefault: true },
    METRIC_TYPE_DEFINITIONS.sensitivityStandalone,
  ],
  contentSet: [
    { ...METRIC_TYPE_DEFINITIONS.netContribution, isDefault: true },
    {
      ...METRIC_TYPE_DEFINITIONS.currencyExposure,
      disabled: true,
      tooltip: "This content set does not support currency exposure",
    },
    METRIC_TYPE_DEFINITIONS.zScore,
  ],
  sensitivityContentSet: [
    METRIC_TYPE_DEFINITIONS.netContribution,
    { ...METRIC_TYPE_DEFINITIONS.currencyExposure, isDefault: true },
    METRIC_TYPE_DEFINITIONS.zScore,
  ],
  beta: [
    METRIC_TYPE_DEFINITIONS.betaNetContribution,
    { ...METRIC_TYPE_DEFINITIONS.betaStandalone, isDefault: true },
  ],
  performance: [
    { ...METRIC_TYPE_DEFINITIONS.cumulativePercent, isDefault: true },
    METRIC_TYPE_DEFINITIONS.cumulativeCurrency,
  ],
  factorPerformance: [
    { ...METRIC_TYPE_DEFINITIONS.cumulativePercent, isDefault: true },
    METRIC_TYPE_DEFINITIONS.cumulativeCurrency,
  ],
  factorSensitivity: [
    { ...METRIC_TYPE_DEFINITIONS.sensitivityNetContribution, isDefault: true },
    METRIC_TYPE_DEFINITIONS.sensitivityStandalone,
  ],
  default: {
    id: "value",
    isDefault: true,
    format: VALUE_FORMATS.NUMBER,
    dataPath: ({ prefix, factorId, dataPath }) => dataPath || `${prefix}.${factorId}`,
  },
}
